//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class TenantService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Tenant.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/tenant/create', params || { });
	};

	//GeneratorFlag:[Tenant.Delete]
	async delete(tenantId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:tenantId
		}
	
		return await _server.delete('/hub/tenant/delete', {'params':params})
	};

	//GeneratorFlag:[Tenant.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/tenant/detail', {'params':params});
	};

	//GeneratorFlag:[Tenant.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/tenant/list', {'params':params});
	};

	//GeneratorFlag:[Tenant.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/tenant/update', params || { });
	};

//GeneratorFlag:[NewAction]
}